import React from 'react';
interface PhotoPlaceholderProps {
  text?: string;
  className?: string;
}
export function PhotoPlaceholder({
  text = 'FOTO',
  className = ''
}: PhotoPlaceholderProps) {
  return <div className={`bg-marron text-crema flex items-center justify-center border border-dashed border-crema/20 p-6 text-center font-labrada ${className}`} data-id="element-79">
      <span className="max-w-[80%] tracking-widest" data-id="element-80">{text}</span>
    </div>;
}
interface LogoPlaceholderProps {
  className?: string;
  src?: string;
}
export function LogoPlaceholder({
  className = '',
  src = 'https://cdn.magicpatterns.com/uploads/59nbNaRLV1zgmFM8zpfToR/IMAGOTIPO_3C.png'
}: LogoPlaceholderProps) {
  return <div className={`bg-negro flex items-center justify-center overflow-hidden ${className}`} data-id="element-81">
      <img src={src} alt="Lloq'e — Textiles Ancestrales" className="w-full h-full object-contain" data-id="element-82" />
    </div>;
}